// Row component used by the mapping function in VspTable.js
import React from 'react';
import {MdDeleteForever, MdEdit} from 'react-icons/md';




/**
 * support for id returned by server: _id from MongoDB (just in case)
 * or id from Firestore-style noSQL database
 * 
 * tr=table row, td=table data cell element
 * Row components used by the mapping function in VspTable or VspList
 * 
 * ?: optional chaining operator --check for null or undefined
 * ??: nullish coalescing operator ---provides a default value if null or undefined
 * 
 * if a row uses vsp1/vsp2 it uses this component
 * if a row has Vspeed1/Vspeed2 it uses this component
 */

function VspRow({vsp, onDelete, onEdit, canEdit = false }) {
    const rowId = vsp?._id ?? vsp?.id ?? vsp?.item ?? vsp?.name ?? '';

   // Name
    const name = vsp?.name ?? vsp?.item ?? vsp?.id ?? '';

    // Configuration
    const config = vsp?.configuration ?? vsp?.config ?? '';

    // Numeric speeds (support all likely keys)
    const v1 = vsp?.Vspeed1 ?? vsp?.vsp1 ?? vsp?.vs1 ?? '';
    const v2 = vsp?.Vspeed2 ?? vsp?.vsp2 ?? vsp?.vs2 ?? '';

    //console.log('VspRow props:', { vsp, onDelete, onEdit, canEdit });
    return (       
        <tr>
            <td className='Name'>{name}</td>
            <td className='Config'>{config}</td>
            <td className='Vspeed1'>{v1}</td>
            <td className='Vspeed2'>{v2}</td>
            <td className='Unit'>{vsp?.units ?? ''}</td>

            {canEdit && (
            <>
            <td>
                <MdEdit onClick={() => onEdit(vsp)} />
            </td>
            <td>
                <MdDeleteForever onClick={() => onDelete(rowId)} />
            </td>
            </>
            )}
        </tr>
    );
}
export default VspRow;
